import React, { useState } from 'react';

const Faq: React.FC = () => {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  const faqItems = [
    {
      question: 'Was ist ein Aszendent?',
      answer: 'Der Aszendent (Abkürzung AC) ist das Tierkreiszeichen, das zum Zeitpunkt der Geburt des Menschen am östlichen Horizont aufgeht. Es beschreibt, wie der Mensch auf seine Umwelt wirkt und von anderen wahrgenommen wird.'
    },
    {
      question: 'Wie berechne ich meinen Aszendenten?',
      answer: 'Für die genaue Berechnung des Aszendenten sind der Geburtsort und die genaue Geburtszeit notwendig. Nutzen Sie den Aszendent-Rechner auf unserer Webseite, um ihn kostenlos zu berechnen.'
    },
    {
      question: 'Was ist der Unterschied zwischen Aszendent und Deszendent?',
      answer: 'Der Aszendent beschreibt die Reaktion eines Menschen auf seine Umwelt, während der Deszendent zeigt, was einem Menschen fehlt oder was er noch lernen muss. Beide ergänzen sich und sind wichtige Elemente in der Horoskop-Deutung.'
    },
    {
      question: 'Warum ist die Geburtszeit wichtig für die Berechnung?',
      answer: 'Die Geburtszeit ist entscheidend, da sich der Aszendent alle zwei Stunden ändert. Ohne genaue Zeitangabe ist die Berechnung ungenau.'
    }
  ];

  const toggleFaq = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <div id="faq" className="container mt-5">
      <h1 className="text-center mb-4">Häufig gestellte Fragen (FAQs)</h1>
      <div className="accordion" id="faqAccordion">
        {faqItems.map((item, index) => (
          <div key={index} className="accordion-item">
            <h2 className="accordion-header" id={`heading${index}`}>
              <button
                className={`accordion-button ${openIndex === index ? '' : 'collapsed'}`}
                type="button"
                onClick={() => toggleFaq(index)}
                aria-expanded={openIndex === index}
                aria-controls={`collapse${index}`}
              >
                {item.question}
              </button>
            </h2>
            <div
              id={`collapse${index}`}
              className={`accordion-collapse collapse ${openIndex === index ? 'show' : ''}`}
              aria-labelledby={`heading${index}`}
            >
              <div className="accordion-body">
                {item.answer}
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Faq;